import { patchState, Prettify, signalStoreFeature, StateSignals, withMethods, withState, WritableStateSource } from "@ngrx/signals";

export type RequestStatusMethods = {
  resetError(): void;
};

export type RequestStatusHttpError = {
  status: number;
  statusText: string;
  url: string | null;
  message: string;
  error: unknown;
};

export type RequestStatusState = {
  isLoading: boolean;
  hasError: boolean;
  httpStatusCode: number;
  httpError?: RequestStatusHttpError | null;
};

export function withRequestStatus() {
  return signalStoreFeature(
    withState<RequestStatusState>({ isLoading: false, hasError: false, httpStatusCode: 0, httpError: null }),
    withMethods((store: Prettify<StateSignals<RequestStatusState> & WritableStateSource<RequestStatusState>>) => ({
      resetError(): void {
        patchState(store, {
          hasError: false,
          isLoading: false,
          httpStatusCode: 0,
          httpError: null,
        });
      },
    }))
  );
}
